import { FormEvent, useState } from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { Field } from '@/components/common/Field'
import { readError } from '@/services/apiClient'
import { setCustomerStop } from '@/services/customerService'

export function StopReasonDialog({
  customerId,
  customerName,
  placingOnStop,
  onClose,
  onDone,
}: {
  customerId: string
  customerName: string
  placingOnStop: boolean
  onClose: () => void
  onDone: () => void
}) {
  const [reason, setReason] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await setCustomerStop(customerId, placingOnStop, reason.trim())
      onDone()
    } catch (caught) {
      setError(readError(caught))
      setBusy(false)
    }
  }

  return (
    <Modal show onHide={onClose}>
      <form onSubmit={(event) => void submit(event)}>
        <Modal.Header closeButton>
          <Modal.Title>{placingOnStop ? 'Place on stop' : 'Remove stop'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <p>{customerName}</p>
          <Field label={placingOnStop ? 'Why is this customer going on stop?' : 'Why is the stop being removed?'} type="textarea" value={reason} onChange={setReason} required />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" variant={placingOnStop ? 'danger' : 'success'} disabled={busy}>{placingOnStop ? 'Place on stop' : 'Remove stop'}</Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
